export default [
  {
    path: '/ci/sended',
    name: 'ci_sended',
    component: () => import('./SendedCi.vue'),
    meta: {
      name: 'CI - Enviados',
      auth: true,
      user: 'Admin',
    },
  },
]
